export default __webpack_public_path__ + "static/media/pdf.d9f7551b.png";